import { useQuery, UseQueryResult } from 'react-query';
import { AthleteRetrieve } from 'types';
import { client } from 'utils/api-client';

function useAthlete(
  athleteId: string | undefined,
  enabled = true,
): UseQueryResult<{ data: AthleteRetrieve }> {
  return useQuery(['athletes', athleteId], () => client.get(`athletes/${athleteId}/`), {
    enabled: enabled && !!athleteId,
  });
}

export default useAthlete;
